import { ComboboxItem, ComboboxParsedItem, ComboboxParsedItemGroup } from '@mantine/core'

export function isOptionsGroup(item: ComboboxParsedItem): item is ComboboxParsedItemGroup {
  return 'group' in item
}
export interface FilterOptionsInput {
  options: Array<ComboboxParsedItem>
  search: string
  limit: number
}

export function optionsFilter({ options, search, limit }: FilterOptionsInput): Array<ComboboxParsedItem> {
  const parsedSearch = normalize(search.trim())
  const result: Array<ComboboxParsedItem> = []

  for (let i = 0; i < options.length; i += 1) {
    const item = options[i]

    if (result.length === limit) {
      return result
    }

    if (isOptionsGroup(item)) {
      result.push({
        group: item.group,
        items: optionsFilter({
          options: item.items,
          search,
          limit: limit - result.length,
        }) as Array<ComboboxItem>,
      })
    }

    if (!isOptionsGroup(item)) {
      if (normalize(item.label).includes(parsedSearch)) {
        result.push(item)
      }
    }
  }

  return result
}

function normalize(value: string) {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ł/g, 'l')
    .replace(/Ł/g, 'l')
}
